import { SubjectResourceType } from '../types/common/subject-resource-type.enum';

export const createDoidUrn = (type: string, identifier: string) =>
  `urn:doid:arcadia.io:${type.toLowerCase()}!${identifier}`;

export const createUuidUrn = (identifier: string) => `urn:uuid:${identifier}`;

export const ensureDoidUrn = (id: string, type: SubjectResourceType) => {
  if (!id.includes('doid')) {
    return createDoidUrn(type, id);
  }

  return id;
};

export const stripUrn = (urn: string) => (urn.includes('!') ? urn.split('!')[1] : urn);

export const isValidUrnOrUuid = (id: string | undefined): boolean =>
  !!id && (id.includes('urn') || id.includes('uuid'));
